import React from "react";
import { Card } from "../card";

export function CategoriesSkeleton() {
  return (
    <div className="pb-4">
      <div className="flex items-center justify-between pt-2 lg:pt-2 pb-2 lg:pb-4">
        <div className="h-3 bg-secondary opacity-10 rounded-full dark:bg-gray-600 w-20 mb-2.5"></div>
        <div className="w-28 h-8 rounded-md bg-secondary opacity-10 dark:bg-gray-700"></div>
      </div>
      <Card>
        <div className="px-3 py-5">
          <div className="grid grid-cols-2 gap-x-6 gap-y-6 lg:grid-cols-4 xl:gap-x-8">
            {Array.from({ length: 8 }, (_, index) => (
              <div key={index} role="status" className="animate-pulse">
                <div className="flex items-center justify-center h-36 mb-2 bg-gray-300 rounded dark:bg-gray-700"></div>
                <div className="flex items-center justify-between mt-3">
                  <div className="h-2 bg-secondary opacity-10 rounded-full dark:bg-gray-700 w-16 mb-1"></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
